import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { Badge } from "../../generic/badge/Badge";
import { IdBadgePosition } from "../../generic/badge/IdBadgePosition";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
export var ExpansionGridImage = function (_a) {
    var expansionsSizeX = _a.expansionsSizeX, expansionsSizeY = _a.expansionsSizeY, children = _a.children;
    return (React.createElement("div", { className: "expansion-menu__grid-image" },
        React.createElement("div", { className: "pos-rel" },
            React.createElement(Icon, { icon: IdIcon.ExpandFarmIcn, styleId: IdStyles.IconExtraLarge },
                React.createElement(Badge, null,
                    React.createElement("div", { className: "flex flex--guts" },
                        React.createElement(Icon, { icon: IdIcon.GridIcn, styleId: IdStyles.IconMedium },
                            React.createElement(Badge, { position: IdBadgePosition.BottomRight },
                                React.createElement("div", { className: IdStyles.TextNormal },
                                    expansionsSizeX,
                                    "X",
                                    expansionsSizeY))))))),
        children));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/expansions/GraphicExpansion.tsx
// module id = 953
// module chunks = 3